import { useState } from "react";
import classes from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import InputField from "../ui/InputField/InputField";
import CommonButton from "../ui/CommonButton/CommonButton";
import axios from "axios";
import { env } from "../../constants/env";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${env.formIoUrl}/user/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            email: email,
            password: password,
          },
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        setLoading(false);
        throw new Error(result.message || "Login failed.");
      }

      localStorage.setItem("formioUser", JSON.stringify(result));

      console.log("RESPONSE", result);

      getToken(result);

      // Store token or user info as needed
      // localStorage.setItem("formioToken", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjY4MThkNDY2OTg2YjJmZTNmZmI1ODZiMCJ9LCJmb3JtIjp7Il9pZCI6IjY4MThkNDYxOTg2YjJmZTNmZmI1ODY2ZSJ9LCJpYXQiOjE3NDg1MDkxODIsImV4cCI6MTc0ODUyMzU4Mn0.g5GUOiRKl6_SdI120dRKZYTZkkzBocE8fCTubIVxJxw");

      // Navigate after successful login
    } catch (err) {
      setLoading(false);
      setError(err.message);
      console.error("Login failed:", err);
    }
  };

  const getToken = async (data) => {
    try {
      const response = await axios.post(`${env.apiUrl}/api/token`, {
        data,
      });

      console.log("RESPONSE", response.data);
      localStorage.setItem("formioToken", response.data.token);
      // Redirect based on role
      const role = data.data.role; // Assuming data returned from Form.io has this structure
      if (role === "disposalManager") {
        navigate("/disposal");
      } else {
        navigate("/");
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div
      className={`d-flex align-items-center justify-content-center ${classes.main}`}
    >
      <div className={`${classes.inputWrapper}`}>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <div className={`d-flex align-items-center justify-content-center`}>
          <img src="/EDRMS-logo-no-bg.png" alt="EDRMS Logo" />
        </div>
        <div className={`d-flex flex-column`}>
          <InputField
            labelText="Email"
            type="text"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <InputField
            labelText="Password"
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            showEye={true}
          />
        </div>
        <div className={`d-flex align-items-center justify-content-center`}>
          <CommonButton
            text={loading ? "Loading..." : "Log in"}
            className={`mt-3 ${classes.loginButton}`}
            onClick={handleSubmit}
            disabled={loading === true}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
